module.exports = __webpack_public_path__ + "media/פיל.aad07efa.mp3";